export default __webpack_public_path__ + "static/media/lacoste.381f6a88.jpg";